/*
 * @Author: Nora Galvin
 * @Date: 2020-08-17 10:49:45
 * @Last Modified by:   Nora
 * @Last Modified time: 2020-08-17 10:49:45
 */
import template from '@/app/editor/sidebar/templates/gfElement/separator.html';

export const separatorSettings = [
  {
    name: 'separator-color',
    caption: 'Color',
    type: 'text',
    id: 'separator-color',
    class: 'gryff-color',
    value: '#000',
    mode: 'responsive-mode',
    target: '.gf_separator',
    ref: 'css|border-color',
  },
  {
    name: 'separator-type',
    id: 'separator-type',
    caption: 'Type',
    type: 'select',
    options: {
      solid: 'Solid',
      dashed: 'Dashed',
      dotted: 'Dotted',
    },
    mode: 'responsive-mode',
    target: '.gf_separator',
    ref: 'css|border-style',
  },
  {
    caption: 'Dimension',
    type: 'group',
    mode: 'responsive-mode',
    items: [
      {
        name: 'width',
        id: 'width',
        caption: 'Width',
        type: 'text',
        default_value: '',
        mode: 'responsive-mode',
        target: '.gf_separator',
        ref: 'css|width',
      },
      {
        name: 'height',
        id: 'height',
        caption: 'Height',
        type: 'text',
        default_value: '',
        mode: 'responsive-mode',
        target: '.gf_separator',
        ref: 'css|border-top-width',
      },
    ],
  },
  {
    name: 'alignment',
    id: 'alignment',
    caption: 'Alignment',
    type: 'select',
    class: 'gf_to-align',
    options: {
      left: 'Left',
      center: 'Center',
      right: 'Right',
    },
    default_value: '',
    mode: 'responsive-mode',
    target: '.elm',
    ref: 'class|align',
  },
  {
    name: 'extra_class',
    caption: 'Extra Class',
    type: 'text',
    desc: 'If you wish to style particular content element differently, then use this field to add a class name and then refer to it in your css file.',
    target: '.elm',
    ref: 'class|classname',
  },
];

export default {
  name: 'Separator',
  slug: 'separator',
  class: 'gf_separator',
  id: 'md-separator',
  html: template(),
  settings: separatorSettings,
};
